export const headerTextStyles = 'text-j-dark-600 text-xl font-medium mt-0';
export const labelTextStyles =
  'text-j-dark-600 whitespace-nowrap font-semibold text-sm';
